import { Base } from '@app/shared/model';
import { Course } from '.';
import { ExperimentalTarget } from '@app/shared/enum';

export class Auction extends Base {
  title: string;
  description: string;

  target: ExperimentalTarget;

  courseId: number;
  course: Course;

  startDate: Date;
  finishDate: Date;
  maxNumberBids: number;

  checkTeacherAvailability: boolean = true;
  whatsAppNotification: boolean = false;
  emailNotification: boolean = false;

  constructor(contentResponse: any) {
    super(contentResponse);

    this.title = contentResponse.title;
    this.description = contentResponse.description;
    this.target = contentResponse.target;

    this.courseId = parseInt(contentResponse.courseId);
    if (contentResponse.course) {
      this.course = contentResponse.course;
    }

    this.startDate = new Date(contentResponse.startDate);
    this.finishDate = new Date(contentResponse.finishDate);
    this.maxNumberBids = parseInt(contentResponse.maxNumberBids);

    this.checkTeacherAvailability = contentResponse.checkTeacherAvailability;
    this.whatsAppNotification = contentResponse.whatsAppNotification;
    this.emailNotification = contentResponse.emailNotification;
  }
}
